export const hiddenByRole = (id, arrayRoles) => {
  return arrayRoles.find((role) => role === id);
};
